module.exports = __webpack_public_path__ + "static/img/parking1.dfa896fd.jpg";